import { OBJECT_ID } from './constants';
/**
 * This gets the object id of an given object, or null if it has not been identified
 *
 * @param {Identifiable<any>} values
 *
 * @return {boolean}
 */
export var getObjectId = function (values) {
    var result = values[OBJECT_ID];
    return result === undefined ? null : result;
};
//# sourceMappingURL=getObjectId.js.map